import Vue from 'vue';
import router from './router'
import store from './store/index'
import Api from './api/index.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/reset.css'
import './assets/styles/common.css'
import '@/assets/icons/iconfont.css'
import SvgIcon from 'vue-svgicon'
import App from './App.vue';

Vue.use(ElementUI);
Vue.use(SvgIcon, {
  tagName: 'svg-icon'
});

Vue.prototype.$api = Api;
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js